import { render, staticRenderFns } from "./BaseFormSection.vue?vue&type=template&id=042ac73c&scoped=true&"
var script = {}
import style0 from "./BaseFormSection.vue?vue&type=style&index=0&id=042ac73c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042ac73c",
  null
  
)

export default component.exports